export default __webpack_public_path__ + "static/media/no_user_avatar.60a0e726.svg";